import { BookMarked, ArrowUpRight } from "lucide-react";

const AMAZON_URL = "https://www.amazon.com/s?k=Dennis+Louden";

export const AuthorFollow = () => (
  <div
    data-testid="author-follow"
    className="mt-12 rounded-2xl border border-[#7C3AED]/40 bg-[#7C3AED]/10 p-8"
  >
    <span className="text-xs uppercase tracking-[0.3em] text-[#7C3AED]">
      Follow Me as an Author
    </span>
    <p className="mt-3 max-w-lg text-base leading-relaxed text-white/70">
      New releases, new editions, and what's next — follow my author journey and
      explore the full collection on Amazon.
    </p>
    <a
      data-testid="author-follow-amazon-btn"
      href={AMAZON_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="magnetic-btn mt-6 inline-flex items-center gap-3 rounded-full bg-white px-7 py-3.5 text-sm font-semibold uppercase tracking-wider text-black transition-colors hover:bg-[#7C3AED] hover:text-white"
    >
      <BookMarked size={18} />
      Explore My Books on Amazon
      <ArrowUpRight size={16} />
    </a>
  </div>
);

export default AuthorFollow;
